<div class="product-card" [routerLink]="productLink">
  <div class="product-image-container">
    @if (product().images && product().images.length > 0) {
      <img [ngSrc]="product().images[0]" [alt]="title || 'Product image'" fill priority/>
    }
  </div>
  <div class="product-info">
    <div class="product-header">
      <h2 class="product-title">{{ title }}</h2>
      @if (productCode) {
        <span class="product-code">{{ productCode }}</span>
      }
    </div>
  </div>
</div>
